import { render, staticRenderFns } from "./NoResult.vue?vue&type=template&id=10208654&scoped=true&"
import script from "./NoResult.vue?vue&type=script&lang=ts&"
export * from "./NoResult.vue?vue&type=script&lang=ts&"
import style0 from "./NoResult.vue?vue&type=style&index=0&id=10208654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10208654",
  null
  
)

component.options.__file = "NoResult.vue"
export default component.exports